/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Challenge_QuestionInputs */

const en_onboarding_challenge_question = /** @type {(inputs: Onboarding_Challenge_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's your biggest challenge with staying on top of your reading?`)
};

const es_onboarding_challenge_question = /** @type {(inputs: Onboarding_Challenge_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es tu mayor desafío para mantenerte al día con tu lectura?`)
};

/**
* | output |
* | --- |
* | "What's your biggest challenge with staying on top of your reading?" |
*
* @param {Onboarding_Challenge_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_challenge_question = /** @type {((inputs?: Onboarding_Challenge_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Challenge_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_challenge_question(inputs)
	return en_onboarding_challenge_question(inputs)
});